import React from 'react';
import PropTypes from 'prop-types';
import { STEP_SECTIONS } from '../../config/constants';

// Active dot position (0-indexed) per section. Dot 4 (index 3) is reserved and never activates.
const ACTIVE_DOT_INDEX = {
  basics:    0,
  messaging: 1,
  guidebook: 2,
};

const TOTAL_DOTS = 4;

const StepProgressIndicator = ({ currentSection }) => {
  const activeIdx = ACTIVE_DOT_INDEX[currentSection];

  return (
    <div className="hg-step-indicator" data-testid="step-progress-indicator">
      {Array.from({ length: TOTAL_DOTS }).map((_, i) => {
        let modifier = '';
        if (i < activeIdx) modifier = ' hg-step-indicator__dot--completed';
        else if (i > activeIdx) modifier = ' hg-step-indicator__dot--upcoming';
        // i === activeIdx → no modifier (base class = active pill)
        return (
          <span
            key={i}
            className={`hg-step-indicator__dot${modifier}`}
          />
        );
      })}
      <span className="sc-prog__lbl">
        {STEP_SECTIONS[currentSection]}
      </span>
    </div>
  );
};

StepProgressIndicator.propTypes = {
  currentSection: PropTypes.oneOf(['basics', 'guidebook', 'messaging']).isRequired,
};

export default StepProgressIndicator;
